namespace GeniuzPOS.AdvPromo {
    export interface PsPromoCampaignRow {
        Id?: number;
        PromoCampaign?: string;
        PromoCampName?: string;
        FullName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        UpdateDate?: string;
    }

    export namespace PsPromoCampaignRow {
        export const idProperty = 'PromoCampaign';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'AdvPromo.PsPromoCampaign';
        export const lookupKey = 'AdvPromo.PsPromoCampaign';

        export function getLookup(): Q.Lookup<PsPromoCampaignRow> {
            return Q.getLookup<PsPromoCampaignRow>('AdvPromo.PsPromoCampaign');
        }
        export const deletePermission = '4ADVANCED_PROMOTION:เพิ่มโปรโมชั่น:Delete';
        export const insertPermission = '4ADVANCED_PROMOTION:เพิ่มโปรโมชั่น:Modify';
        export const readPermission = '*';
        export const updatePermission = '4ADVANCED_PROMOTION:เพิ่มโปรโมชั่น:Modify';

        export declare const enum Fields {
            Id = "Id",
            PromoCampaign = "PromoCampaign",
            PromoCampName = "PromoCampName",
            FullName = "FullName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            UpdateDate = "UpdateDate"
        }
    }
}
